export interface DataAnalyticsAttributes {
  "data-analytics-event"?: string;
  "data-analytics-props"?: string;
}

export const getDataAnalyticsProps = (props: Record<string, any>) => {
  return {
    "data-analytics-event": props?.["data-analytics-event"],
    "data-analytics-props": props?.["data-analytics-props"],
  };
};
